import {types} from './types';

const initialState = {
    list: {
        data: [],
        countPage: 1
    },
    replenishment: {
        data: [],
        countPage: 1
    },
    shift: {
        data: [],
        countPage: 0
    }
}

export function replenishmentMobileReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_REPLENISHMENT_REPORT:
            return { ...state, list: action.payload};
        case types.SET_REPLENISHMENT:
            return { ...state, replenishment: action.payload};
        case types.SET_SHIFT:
            return { ...state, shift: action.payload};
        default:
            return state
    }
}